import isArray from 'lodash/isArray';
import flatten from 'lodash/flatten';
import { citationLiteratureFormatter } from '@Services/FormatUtils';

const PREFIX = 'data-tracking';

export const _parseJournals = (journals) => {
  const issueNumbers = [];
  const volumeNumbers = [];

  if (journals && journals.length && isArray(journals)) {
    journals.forEach((journal) => {
      if (journal.issueVolume) {
        volumeNumbers.push(journal.issueVolume);
      }
      if (journal.issueNo) {
        issueNumbers.push(journal.issueNo);
      }
    });
  }

  return { issueNumbers, volumeNumbers };
};

/**
 * @ngdoc method
 * @name prepare
 * @methodOf PrepareTrackingDataHelper
 * @param {Object} data
 * @returns {Object}
 * @description generates all necessary data attributes for tracking in object format
 */
export const prepare = (data) => {
  const attrs = {};

  const {
    id,
    targetCitationId,
    type,
    title,
    citationPatents,
    citationJournals,
    authors,
    fullTextUrl,
    entryDate,
    publicationDate,
    keywords,
  } = data;

  attrs[`${PREFIX}-id`] = id || targetCitationId;
  attrs[`${PREFIX}-citation-type`] = type;
  attrs[`${PREFIX}-publication-type`] = type;
  attrs[`${PREFIX}-doc-link`] = fullTextUrl;
  attrs[`${PREFIX}-title`] = title;

  if (type && (title || citationPatents || citationJournals)) {
    attrs[`${PREFIX}-name`] = `${type}:${title || citationLiteratureFormatter(citationPatents || citationJournals, true)}`;
  }

  if (authors && authors.length && isArray(authors)) {
    attrs[`${PREFIX}-author-names`] = authors.map((author) => author.author).join(' ');
  }

  if (entryDate) {
    attrs[`${PREFIX}-online-date`] = new Date(entryDate).getTime().toString();
  }
  if (publicationDate) {
    attrs[`${PREFIX}-publication-date`] = new Date(publicationDate).getTime().toString();
  }
  if (keywords) {
    const mappedKeywords = keywords.map((keyword) => keyword.value);
    attrs[`${PREFIX}-index-terms`] = flatten(mappedKeywords).join('; ');
  }

  const { issueNumbers, volumeNumbers } = _parseJournals(citationJournals);
  if (issueNumbers.length) {
    attrs[`${PREFIX}-issue-number`] = issueNumbers.join(' ');
  }
  if (volumeNumbers.length) {
    attrs[`${PREFIX}-volume-number`] = volumeNumbers.join(' ');
  }

  return attrs;
};
